// components/sessions/SessionFilters.js
import React from 'react';
import {
  Box, Grid, TextField, MenuItem, FormControlLabel, Switch,
  Divider, Chip, Button
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

const SessionFilters = ({ filters, setFilters, sessionType }) => {
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };
  
  const handleReset = () => {
    setFilters({
      status: 'all',
      dateRange: 'all',
      includeEmpty: false,
      agentFilter: 'all'
    });
  };
  
  return (
    <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            fullWidth
            size="small"
            label="Stato"
            value={filters.status}
            onChange={(e) => handleFilterChange('status', e.target.value)}
          >
            <MenuItem value="all">Tutte</MenuItem>
            <MenuItem value="active">Attive</MenuItem>
            <MenuItem value="archived">Archiviate</MenuItem>
            <MenuItem value="completed">Completate</MenuItem>
          </TextField>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            fullWidth
            size="small"
            label="Periodo"
            value={filters.dateRange}
            onChange={(e) => handleFilterChange('dateRange', e.target.value)}
          >
            <MenuItem value="all">Tutto</MenuItem>
            <MenuItem value="today">Oggi</MenuItem>
            <MenuItem value="week">Ultima settimana</MenuItem>
            <MenuItem value="month">Ultimo mese</MenuItem>
            <MenuItem value="year">Ultimo anno</MenuItem>
          </TextField>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Switch
                checked={filters.includeEmpty}
                onChange={(e) => handleFilterChange('includeEmpty', e.target.checked)}
              />
            }
            label="Includi vuote"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Button
            variant="outlined"
            startIcon={<ClearIcon />}
            onClick={handleReset}
            fullWidth
          >
            Reset Filtri
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SessionFilters;